<template>
  <ValidationProvider v-slot="{ errors }" :name="`'${label}'`" :rules="rules" :vid="vid">
    <color-picker
        v-model="innerValue"
        :error-messages="errors"
        :readonly="readonly"
        :dense="dense"
        :required-color="requiredColor"
        :required="required"
        @input="change" />
  </ValidationProvider>
</template>

<script>
  import ColorPicker from './ColorPicker.vue'
  export default {
    components: {
      ColorPicker
    },
    props: {
      value: {
        type: String,
        default: null
      },
      rules: [String, Object],
      label: {
        type: String,
        default: ''
      },
      readonly: {
        type: Boolean,
        default: false
      },
      dense: {
        type: Boolean,
        default: false
      },
      requiredColor: {
        type: String,
        default: 'requiredfield'
      },
      errorMessages: Array,
      vid: {
        type: String,
        default: null
      }
    },
    data () {
      return {
        innerValue: null
      }
    },
    computed: {
      required () {
        if (!this.rules) {
          return false
        }
        return (this.rules.hasOwnProperty('required') && this.rules.required) ||
          (!this.rules.hasOwnProperty('required') && !!this.rules.length && this.rules.includes('required'))
      }
    },
    watch: {
      value: {
        immediate: true,
        handler (newVal) {
          if (newVal !== this.innerValue) {
            this.innerValue = newVal
          }
        }
      }
      // innerValue (val) {
      //   this.$emit('input', val)
      // }
    },
    methods: {
      change: function (value) {
        this.$emit('input', value)
        this.$emit('change', value)
      }
    }
  }
</script>
